export const ANIMATION_PAGE_DELAY: number = 100;
export const ANIMATION_PAGE_DURATION: number = 300;
